// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__MeRk3","col":"CardReaderDesc_col__Acek7","label":"CardReaderDesc_label__3T7Bz"};